(function () {
  function startRinging(ringtone, flash) {
    var hard = Math.random() < 0.1;
    ringtone.classList.add(hard ? "shake-hard" : "shake");
    flash.classList.add("ringing");
    setTimeout(function () {
      stopRinging(ringtone, flash);
    }, 2000 + Math.random() * 5000);
  }

  function stopRinging(ringtone, flash) {
    ringtone.classList.remove("shake");
    ringtone.classList.remove("shake-hard");
    flash.classList.remove("ringing");
    setTimeout(function () {
      startRinging(ringtone, flash);
    }, 1000 + Math.random() * 3000);
  }

  function startComplaintsRotation() {
    complaintsRotation = setInterval(function () {
      var complaintsContainer = document.querySelector("#proposal .complaints");
      var complaints = document.querySelectorAll("#proposal .complaints > div");
      var movingElement = complaints.item(0);
      Velocity(
        complaintsContainer,
        { left: "-150px" },
        {
          duration: 150,
          easing: "easeInExpo",
          complete: function () {
            complaintsContainer.removeChild(movingElement);
            complaintsContainer.appendChild(movingElement);
          },
        }
      );
      Velocity(complaintsContainer, { left: "153px" }, { duration: 0 });
      Velocity(
        complaintsContainer,
        { left: "0px" },
        { duration: 500, easing: "easeOutExpo" }
      );
    }, 5000);
  }

  function onWindowResize() {
    if (complaintsRotation) clearInterval(complaintsRotation);
    if (window.innerWidth && window.innerWidth < 768) {
      startComplaintsRotation();
    }
  }

  var images = document.querySelectorAll(".complaints .image");
  images.forEach((image) => {
    var ringtone = image.querySelector(".ringtone");
    var flash = image.querySelector(".flash");
    stopRinging(ringtone, flash);
  });

  var complaintsRotation = null;
  window.onresize = onWindowResize;
  onWindowResize();

  var messages = [
    document.querySelector(".notification-message-lineworks"),
    document.querySelector(".notification-message-slack"),
    document.querySelector(".notification-message-chatwork"),
    document.querySelector(".notification-message-line"),
    document.querySelector(".notification-message-email"),
    document.querySelector(".notification-message-googlechat"),
    document.querySelector(".notification-message-teams"),
  ];
  var windows = [
    document.querySelector(".notification-window-lineworks"),
    document.querySelector(".notification-window-slack"),
    document.querySelector(".notification-window-chatwork"),
    document.querySelector(".notification-window-line"),
    document.querySelector(".notification-window-email"),
    document.querySelector(".notification-window-googlechat"),
    document.querySelector(".notification-window-teams"),
  ];

  function switchMessangers() {
    var showingMessage = messages[1];
    var hidingMessage = messages[0];
    var showingWindow = windows[1];
    var hidingWindow = windows[0];
    Velocity(
      hidingMessage,
      { transform: ["scale(1.03)", "scale(1)"] },
      { duration: 300 }
    );
    Velocity(
      hidingMessage,
      { transform: ["scale(0.8)", "scale(1.03)"] },
      { easing: "easeInExpo", duration: 300 }
    );
    Velocity(
      showingMessage,
      { transform: ["scale(1.05)", "scale(0.9)"], opacity: [1, 0] },
      {
        delay: 600,
        duration: 200,
        begin: function () {
          showingMessage.style["z-index"] = 101;
          showingMessage.style.display = "block";
          hidingMessage.style["z-index"] = 100;
          hidingMessage.style.display = "none";
        },
      }
    );
    Velocity(
      showingMessage,
      { transform: ["scale(1)", "scale(1.05)"] },
      { easing: "easeOutExpo", duration: 700 }
    );
    Velocity(
      showingWindow,
      { opacity: [1, 0] },
      {
        duration: 300,
        begin: function() {
          showingWindow.style["z-index"] = 101;
          hidingWindow.style["z-index"] = 100;
        },
        complete: function () {
          hidingWindow.style.opacity = 0;
        },
      }
    );
    messages.push(messages.shift());
    windows.push(windows.shift());
  }
  setInterval(switchMessangers, 5000);
  switchMessangers();

  // ページ最上部ではメニューにドロップシャドウを付けない
  window.addEventListener('scroll', function(e) {
    var header = document.getElementById('header');
    if (window.scrollY === 0) {
      header.classList.add("no-shadow");
    } else {
      header.classList.remove("no-shadow");
    }
  });
})();
